import { BigNumber } from "@ethersproject/bignumber";
import { BigIntWithDecimals } from "./bigint-with-decimals";

/**
 * @deprecated Use `BigIntWithDecimals` instead
 */
export interface BigNumberWithDecimals {
  bigNumber: BigNumber;
  decimals: number;
}

/**
 * @deprecated Use `BigIntWithDecimals` instead
 */
export const createBigNumberWithDecimals = (
  bigNumber: BigNumber,
  decimals: number
) => ({
  bigNumber,
  decimals,
});

/**
 * @deprecated Use `BigIntWithDecimals` instead
 */
export const fromBigIntWithDecimals = ({
  value,
  decimals,
}: BigIntWithDecimals): BigNumberWithDecimals => ({
  decimals,
  bigNumber: BigNumber.from(value),
});
